import React, { useState } from "react";
import IconTooltip from "./IconTooltip";
import I18n from 'i18n.js.erb'
import CopyButton from "./CopyButtonComponent";



const BlockchainPublicKeyCopyButton = ({ publicKey }) => {
  const [clicked, setClicked] = useState(null)

  return <IconTooltip
      tooltipPosition={'top'}
      tooltipTitle={''}
      tooltipContent={ I18n.t('js.profilePage.copy') }
      tooltipContent2={ clicked && I18n.t('js.profilePage.copied') }
      iconColor={'#049FE3'}
      customComponentToRender={
        <CopyButton
          divClassName="d-flex justify-content-center align-items-center text-center p-2 br-50px ml-2 mb-1 cursor-pointer bg-aig-gradient"
          color="color-white"
          text={publicKey}
          onCopyCallback={() => {setClicked(true)}}
          onTimeOutCallback={() => {setClicked(false)}}
        />
      }
    />
}

export default BlockchainPublicKeyCopyButton;